export default __webpack_public_path__ + "static/media/restaurado.0caaac12.svg";